import { render, staticRenderFns } from "./TraceabilityView.vue?vue&type=template&id=baeac664&scoped=true&"
import script from "./TraceabilityView.vue?vue&type=script&lang=js&"
export * from "./TraceabilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baeac664",
  null
  
)

export default component.exports